package fr.manyverse.app.infrastructure.serialization

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonBuilder

/**
 * Instance [Json] à utiliser pour tout (dé)codage de données de l'app, y compris par le client
 * Supabase.
 *
 * Par défaut, kotlinx.serialization recopie un extrait du JSON en échec (`JSON input: …`) dans le
 * message de ses exceptions. Loggées en erreur, elles l'enverraient à Sentry : contenu de fiches,
 * de notes ou de messages. Le chemin du champ fautif (`$.characters[0].name`) reste dans le
 * message ; seules les valeurs et les clés de Map sont masquées.
 */
@OptIn(ExperimentalSerializationApi::class)
fun appJson(configure: JsonBuilder.() -> Unit = {}): Json = Json {
    exceptionsWithDebugInfo = false
    configure()
}
